import { useEffect, useState } from 'react';

const useDeviceWidth = () => {
    // const [isMobileDevice, setIsMobileDevice] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        // const checkMobileDevice = () => {
        //     setIsMobileDevice(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
        // };
        const handleResize = () => setWidth(window.innerWidth);
        // checkMobileDevice();
        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return width;
};

export default useDeviceWidth;
